import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Import the main App component
import './style.css';

const root = ReactDOM.createRoot(document.querySelector('#root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);